(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-gk-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      gallery.addEventListener('click', event => {
        const button = event.target.closest('[data-gk-image]');
        if (!button) return;
        const main = gallery.querySelector('.gk-preview-main');
        main.src = button.dataset.gkImage;
        main.alt = button.querySelector('img').alt;
        gallery.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      });
    });
    root.querySelectorAll('[data-gk-countdown]').forEach(countdown => {
      if (countdown.dataset.ready) return;
      countdown.dataset.ready = 'true';
      const deadline = Date.parse(countdown.dataset.gkCountdown);
      if (!Number.isFinite(deadline)) return;
      const tick = () => {
        const remaining = Math.floor((deadline - Date.now()) / 1000);
        countdown.hidden = remaining <= 0;
        if (remaining <= 0) return;
        [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60].forEach((value, i) => {
          countdown.querySelectorAll('b')[i].textContent = String(value).padStart(2, '0');
        });
      };
      tick();
      const timer = setInterval(() => {
        if (!countdown.isConnected || Date.now() >= deadline) { countdown.hidden = true; clearInterval(timer); return; }
        tick();
      }, 1000);
    });
  };
  document.addEventListener('DOMContentLoaded', () => initialize());
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
